
// cookies script 16.10.23

let ageBtn = Array.from(document.querySelectorAll('.age-confirmation__button'))
let agePopupTrigger = document.querySelectorAll('.popup-age-trigger')

agePopupTrigger.forEach((el)=>{
    el.addEventListener('click', function (){
        let parentTrigger = this.parentNode
        parentTrigger.classList.add('active')
    })
})
ageBtn.forEach((item)=>{
    item.addEventListener('click', function (el) {
        Cookies.set('AgeVarified', 'true', { expires: 1 })
        let bodyTag = document.querySelector('body')
        bodyTag.classList.add('varified-age')
    })
})


